// extracted by mini-css-extract-plugin
export default {"root":"MobilePayoff_root__GCFFx","hide":"MobilePayoff_hide__QzsDc"};